var colors = {
  white: 'fmc-color-white',
  black: 'fmc-color-black',
  'gray-5': 'fmc-color-gray-5',
  'gray-10': 'fmc-color-gray-10',
  'gray-20': 'fmc-color-gray-20',
  'gray-30': 'fmc-color-gray-30',
  'gray-40': 'fmc-color-gray-40',
  'gray-50': 'fmc-color-gray-50',
  'gray-60': 'fmc-color-gray-60',
  'gray-70': 'fmc-color-gray-70',
  'gray-80': 'fmc-color-gray-80',
  'gray-90': 'fmc-color-gray-90',
  'gray-95': 'fmc-color-gray-95',
  'gray-100': 'fmc-color-gray-100',
  'gray-10A': 'fmc-color-gray-10A',
  'green-5': 'fmc-color-green-5',
  'green-10': 'fmc-color-green-10',
  'green-20': 'fmc-color-green-20',
  'green-30': 'fmc-color-green-30',
  'green-40': 'fmc-color-green-40',
  'green-50': 'fmc-color-green-50',
  'green-60': 'fmc-color-green-60',
  'green-70': 'fmc-color-green-70',
  'green-80': 'fmc-color-green-80',
  'green-90': 'fmc-color-green-90',
  'green-95': 'fmc-color-green-95',
  'green-100': 'fmc-color-green-100',
  'green-10A': 'fmc-color-green-10A',
  'teal-5': 'fmc-color-teal-5',
  'teal-10': 'fmc-color-teal-10',
  'teal-20': 'fmc-color-teal-20',
  'teal-30': 'fmc-color-teal-30',
  'teal-40': 'fmc-color-teal-40',
  'teal-50': 'fmc-color-teal-50',
  'teal-60': 'fmc-color-teal-60',
  'teal-70': 'fmc-color-teal-70',
  'teal-80': 'fmc-color-teal-80',
  'teal-90': 'fmc-color-teal-90',
  'teal-95': 'fmc-color-teal-95',
  'teal-100': 'fmc-color-teal-100',
  'teal-10A': 'fmc-color-teal-10A',
  'lightblue-5': 'fmc-color-lightblue-5',
  'lightblue-10': 'fmc-color-lightblue-10',
  'lightblue-20': 'fmc-color-lightblue-20',
  'lightblue-30': 'fmc-color-lightblue-30',
  'lightblue-40': 'fmc-color-lightblue-40',
  'lightblue-50': 'fmc-color-lightblue-50',
  'lightblue-60': 'fmc-color-lightblue-60',
  'lightblue-70': 'fmc-color-lightblue-70',
  'lightblue-80': 'fmc-color-lightblue-80',
  'lightblue-90': 'fmc-color-lightblue-90',
  'lightblue-95': 'fmc-color-lightblue-95',
  'lightblue-100': 'fmc-color-lightblue-100',
  'lightblue-10A': 'fmc-color-lightblue-10A',
  'blue-5': 'fmc-color-blue-5',
  'blue-10': 'fmc-color-blue-10',
  'blue-20': 'fmc-color-blue-20',
  'blue-30': 'fmc-color-blue-30',
  'blue-40': 'fmc-color-blue-40',
  'blue-50': 'fmc-color-blue-50',
  'blue-60': 'fmc-color-blue-60',
  'blue-70': 'fmc-color-blue-70',
  'blue-80': 'fmc-color-blue-80',
  'blue-90': 'fmc-color-blue-90',
  'blue-95': 'fmc-color-blue-95',
  'blue-100': 'fmc-color-blue-100',
  'blue-10A': 'fmc-color-blue-10A',
  'indigo-5': 'fmc-color-indigo-5',
  'indigo-10': 'fmc-color-indigo-10',
  'indigo-20': 'fmc-color-indigo-20',
  'indigo-30': 'fmc-color-indigo-30',
  'indigo-40': 'fmc-color-indigo-40',
  'indigo-50': 'fmc-color-indigo-50',
  'indigo-60': 'fmc-color-indigo-60',
  'indigo-70': 'fmc-color-indigo-70',
  'indigo-80': 'fmc-color-indigo-80',
  'indigo-90': 'fmc-color-indigo-90',
  'indigo-95': 'fmc-color-indigo-95',
  'indigo-100': 'fmc-color-indigo-100',
  'indigo-10A': 'fmc-color-indigo-10A',
  'purple-5': 'fmc-color-purple-5',
  'purple-10': 'fmc-color-purple-10',
  'purple-20': 'fmc-color-purple-20',
  'purple-30': 'fmc-color-purple-30',
  'purple-40': 'fmc-color-purple-40',
  'purple-50': 'fmc-color-purple-50',
  'purple-60': 'fmc-color-purple-60',
  'purple-70': 'fmc-color-purple-70',
  'purple-80': 'fmc-color-purple-80',
  'purple-90': 'fmc-color-purple-90',
  'purple-95': 'fmc-color-purple-95',
  'purple-100': 'fmc-color-purple-100',
  'purple-10A': 'fmc-color-purple-10A',
  'pink-5': 'fmc-color-pink-5',
  'pink-10': 'fmc-color-pink-10',
  'pink-20': 'fmc-color-pink-20',
  'pink-30': 'fmc-color-pink-30',
  'pink-40': 'fmc-color-pink-40',
  'pink-50': 'fmc-color-pink-50',
  'pink-60': 'fmc-color-pink-60',
  'pink-70': 'fmc-color-pink-70',
  'pink-80': 'fmc-color-pink-80',
  'pink-90': 'fmc-color-pink-90',
  'pink-95': 'fmc-color-pink-95',
  'pink-100': 'fmc-color-pink-100',
  'pink-10A': 'fmc-color-pink-10A',
  'red-5': 'fmc-color-red-5',
  'red-10': 'fmc-color-red-10',
  'red-20': 'fmc-color-red-20',
  'red-30': 'fmc-color-red-30',
  'red-40': 'fmc-color-red-40',
  'red-50': 'fmc-color-red-50',
  'red-60': 'fmc-color-red-60',
  'red-70': 'fmc-color-red-70',
  'red-80': 'fmc-color-red-80',
  'red-90': 'fmc-color-red-90',
  'red-95': 'fmc-color-red-95',
  'red-100': 'fmc-color-red-100',
  'red-10A': 'fmc-color-red-10A',
  'orange-5': 'fmc-color-orange-5',
  'orange-10': 'fmc-color-orange-10',
  'orange-20': 'fmc-color-orange-20',
  'orange-30': 'fmc-color-orange-30',
  'orange-40': 'fmc-color-orange-40',
  'orange-50': 'fmc-color-orange-50',
  'orange-60': 'fmc-color-orange-60',
  'orange-70': 'fmc-color-orange-70',
  'orange-80': 'fmc-color-orange-80',
  'orange-90': 'fmc-color-orange-90',
  'orange-95': 'fmc-color-orange-95',
  'orange-100': 'fmc-color-orange-100',
  'orange-10A': 'fmc-color-orange-10A',
  'yellow-5': 'fmc-color-yellow-5',
  'yellow-10': 'fmc-color-yellow-10',
  'yellow-20': 'fmc-color-yellow-20',
  'yellow-30': 'fmc-color-yellow-30',
  'yellow-40': 'fmc-color-yellow-40',
  'yellow-50': 'fmc-color-yellow-50',
  'yellow-60': 'fmc-color-yellow-60',
  'yellow-70': 'fmc-color-yellow-70',
  'yellow-80': 'fmc-color-yellow-80',
  'yellow-90': 'fmc-color-yellow-90',
  'yellow-95': 'fmc-color-yellow-95',
  'yellow-100': 'fmc-color-yellow-100',
  'yellow-10A': 'fmc-color-yellow-10A',
  'primary-contents': 'fmc-color-primary-contents',
  'primary-container': 'fmc-color-primary-container',
  'primary-container-contents': 'fmc-color-primary-container-contents',
  'secondary-container': 'fmc-color-secondary-container',
  'secondary-container-contents': 'fmc-color-secondary-container-contents',
  'neutral-primary-contents': 'fmc-color-neutral-primary-contents',
  'neutral-primary-container': 'fmc-color-neutral-primary-container',
  'neutral-secondary-contents': 'fmc-color-neutral-secondary-contents',
  'neutral-secondary-container': 'fmc-color-neutral-secondary-container',
  'neutral-tertiary-contents': 'fmc-color-neutral-tertiary-contents',
  'neutral-tertiary-container': 'fmc-color-neutral-tertiary-container',
  'inverse-container': 'fmc-color-inverse-container',
  'inverse-container-contents': 'fmc-color-inverse-container-contents',
  'error-contents': 'fmc-color-error-contents',
  'error-container': 'fmc-color-error-container',
  divider: 'fmc-color-divider',
  outline: 'fmc-color-outline',
  background: 'fmc-color-background'
};
var theme = {
  font: {
    body: 'var(--fmc-font)'
  },
  colors: {
    white: 'var(--fmc-color-white)',
    black: 'var(--fmc-color-black)',
    'gray-5': 'var(--fmc-color-gray-5)',
    'gray-10': 'var(--fmc-color-gray-10)',
    'gray-20': 'var(--fmc-color-gray-20)',
    'gray-30': 'var(--fmc-color-gray-30)',
    'gray-40': 'var(--fmc-color-gray-40)',
    'gray-50': 'var(--fmc-color-gray-50)',
    'gray-60': 'var(--fmc-color-gray-60)',
    'gray-70': 'var(--fmc-color-gray-70)',
    'gray-80': 'var(--fmc-color-gray-80)',
    'gray-90': 'var(--fmc-color-gray-90)',
    'gray-95': 'var(--fmc-color-gray-95)',
    'gray-100': 'var(--fmc-color-gray-100)',
    'gray-10A': 'var(--fmc-color-gray-10A)',
    'green-5': 'var(--fmc-color-green-5)',
    'green-10': 'var(--fmc-color-green-10)',
    'green-20': 'var(--fmc-color-green-20)',
    'green-30': 'var(--fmc-color-green-30)',
    'green-40': 'var(--fmc-color-green-40)',
    'green-50': 'var(--fmc-color-green-50)',
    'green-60': 'var(--fmc-color-green-60)',
    'green-70': 'var(--fmc-color-green-70)',
    'green-80': 'var(--fmc-color-green-80)',
    'green-90': 'var(--fmc-color-green-90)',
    'green-95': 'var(--fmc-color-green-95)',
    'green-100': 'var(--fmc-color-green-100)',
    'green-10A': 'var(--fmc-color-green-10A)',
    'teal-5': 'var(--fmc-color-teal-5)',
    'teal-10': 'var(--fmc-color-teal-10)',
    'teal-20': 'var(--fmc-color-teal-20)',
    'teal-30': 'var(--fmc-color-teal-30)',
    'teal-40': 'var(--fmc-color-teal-40)',
    'teal-50': 'var(--fmc-color-teal-50)',
    'teal-60': 'var(--fmc-color-teal-60)',
    'teal-70': 'var(--fmc-color-teal-70)',
    'teal-80': 'var(--fmc-color-teal-80)',
    'teal-90': 'var(--fmc-color-teal-90)',
    'teal-95': 'var(--fmc-color-teal-95)',
    'teal-100': 'var(--fmc-color-teal-100)',
    'teal-10A': 'var(--fmc-color-teal-10A)',
    'lightblue-5': 'var(--fmc-color-lightblue-5)',
    'lightblue-10': 'var(--fmc-color-lightblue-10)',
    'lightblue-20': 'var(--fmc-color-lightblue-20)',
    'lightblue-30': 'var(--fmc-color-lightblue-30)',
    'lightblue-40': 'var(--fmc-color-lightblue-40)',
    'lightblue-50': 'var(--fmc-color-lightblue-50)',
    'lightblue-60': 'var(--fmc-color-lightblue-60)',
    'lightblue-70': 'var(--fmc-color-lightblue-70)',
    'lightblue-80': 'var(--fmc-color-lightblue-80)',
    'lightblue-90': 'var(--fmc-color-lightblue-90)',
    'lightblue-95': 'var(--fmc-color-lightblue-95)',
    'lightblue-100': 'var(--fmc-color-lightblue-100)',
    'lightblue-10A': 'var(--fmc-color-lightblue-10A)',
    'blue-5': 'var(--fmc-color-blue-5)',
    'blue-10': 'var(--fmc-color-blue-10)',
    'blue-20': 'var(--fmc-color-blue-20)',
    'blue-30': 'var(--fmc-color-blue-30)',
    'blue-40': 'var(--fmc-color-blue-40)',
    'blue-50': 'var(--fmc-color-blue-50)',
    'blue-60': 'var(--fmc-color-blue-60)',
    'blue-70': 'var(--fmc-color-blue-70)',
    'blue-80': 'var(--fmc-color-blue-80)',
    'blue-90': 'var(--fmc-color-blue-90)',
    'blue-95': 'var(--fmc-color-blue-95)',
    'blue-100': 'var(--fmc-color-blue-100)',
    'blue-10A': 'var(--fmc-color-blue-10A)',
    'indigo-5': 'var(--fmc-color-indigo-5)',
    'indigo-10': 'var(--fmc-color-indigo-10)',
    'indigo-20': 'var(--fmc-color-indigo-20)',
    'indigo-30': 'var(--fmc-color-indigo-30)',
    'indigo-40': 'var(--fmc-color-indigo-40)',
    'indigo-50': 'var(--fmc-color-indigo-50)',
    'indigo-60': 'var(--fmc-color-indigo-60)',
    'indigo-70': 'var(--fmc-color-indigo-70)',
    'indigo-80': 'var(--fmc-color-indigo-80)',
    'indigo-90': 'var(--fmc-color-indigo-90)',
    'indigo-95': 'var(--fmc-color-indigo-95)',
    'indigo-100': 'var(--fmc-color-indigo-100)',
    'indigo-10A': 'var(--fmc-color-indigo-10A)',
    'purple-5': 'var(--fmc-color-purple-5)',
    'purple-10': 'var(--fmc-color-purple-10)',
    'purple-20': 'var(--fmc-color-purple-20)',
    'purple-30': 'var(--fmc-color-purple-30)',
    'purple-40': 'var(--fmc-color-purple-40)',
    'purple-50': 'var(--fmc-color-purple-50)',
    'purple-60': 'var(--fmc-color-purple-60)',
    'purple-70': 'var(--fmc-color-purple-70)',
    'purple-80': 'var(--fmc-color-purple-80)',
    'purple-90': 'var(--fmc-color-purple-90)',
    'purple-95': 'var(--fmc-color-purple-95)',
    'purple-100': 'var(--fmc-color-purple-100)',
    'purple-10A': 'var(--fmc-color-purple-10A)',
    'pink-5': 'var(--fmc-color-pink-5)',
    'pink-10': 'var(--fmc-color-pink-10)',
    'pink-20': 'var(--fmc-color-pink-20)',
    'pink-30': 'var(--fmc-color-pink-30)',
    'pink-40': 'var(--fmc-color-pink-40)',
    'pink-50': 'var(--fmc-color-pink-50)',
    'pink-60': 'var(--fmc-color-pink-60)',
    'pink-70': 'var(--fmc-color-pink-70)',
    'pink-80': 'var(--fmc-color-pink-80)',
    'pink-90': 'var(--fmc-color-pink-90)',
    'pink-95': 'var(--fmc-color-pink-95)',
    'pink-100': 'var(--fmc-color-pink-100)',
    'pink-10A': 'var(--fmc-color-pink-10A)',
    'red-5': 'var(--fmc-color-red-5)',
    'red-10': 'var(--fmc-color-red-10)',
    'red-20': 'var(--fmc-color-red-20)',
    'red-30': 'var(--fmc-color-red-30)',
    'red-40': 'var(--fmc-color-red-40)',
    'red-50': 'var(--fmc-color-red-50)',
    'red-60': 'var(--fmc-color-red-60)',
    'red-70': 'var(--fmc-color-red-70)',
    'red-80': 'var(--fmc-color-red-80)',
    'red-90': 'var(--fmc-color-red-90)',
    'red-95': 'var(--fmc-color-red-95)',
    'red-100': 'var(--fmc-color-red-100)',
    'red-10A': 'var(--fmc-color-red-10A)',
    'orange-5': 'var(--fmc-color-orange-5)',
    'orange-10': 'var(--fmc-color-orange-10)',
    'orange-20': 'var(--fmc-color-orange-20)',
    'orange-30': 'var(--fmc-color-orange-30)',
    'orange-40': 'var(--fmc-color-orange-40)',
    'orange-50': 'var(--fmc-color-orange-50)',
    'orange-60': 'var(--fmc-color-orange-60)',
    'orange-70': 'var(--fmc-color-orange-70)',
    'orange-80': 'var(--fmc-color-orange-80)',
    'orange-90': 'var(--fmc-color-orange-90)',
    'orange-95': 'var(--fmc-color-orange-95)',
    'orange-100': 'var(--fmc-color-orange-100)',
    'orange-10A': 'var(--fmc-color-orange-10A)',
    'yellow-5': 'var(--fmc-color-yellow-5)',
    'yellow-10': 'var(--fmc-color-yellow-10)',
    'yellow-20': 'var(--fmc-color-yellow-20)',
    'yellow-30': 'var(--fmc-color-yellow-30)',
    'yellow-40': 'var(--fmc-color-yellow-40)',
    'yellow-50': 'var(--fmc-color-yellow-50)',
    'yellow-60': 'var(--fmc-color-yellow-60)',
    'yellow-70': 'var(--fmc-color-yellow-70)',
    'yellow-80': 'var(--fmc-color-yellow-80)',
    'yellow-90': 'var(--fmc-color-yellow-90)',
    'yellow-95': 'var(--fmc-color-yellow-95)',
    'yellow-100': 'var(--fmc-color-yellow-100)',
    'yellow-10A': 'var(--fmc-color-yellow-10A)',
    'primary-contents': 'var(--fmc-color-primary-contents)',
    'primary-container': 'var(--fmc-color-primary-container)',
    'primary-container-contents': 'var(--fmc-color-primary-container-contents)',
    'secondary-container': 'var(--fmc-color-secondary-container)',
    'secondary-container-contents': 'var(--fmc-color-secondary-container-contents)',
    'neutral-primary-contents': 'var(--fmc-color-neutral-primary-contents)',
    'neutral-primary-container': 'var(--fmc-color-neutral-primary-container)',
    'neutral-secondary-contents': 'var(--fmc-color-neutral-secondary-contents)',
    'neutral-secondary-container': 'var(--fmc-color-neutral-secondary-container)',
    'neutral-tertiary-contents': 'var(--fmc-color-neutral-tertiary-contents)',
    'neutral-tertiary-container': 'var(--fmc-color-neutral-tertiary-container)',
    'inverse-container': 'var(--fmc-color-inverse-container)',
    'inverse-container-contents': 'var(--fmc-color-inverse-container-contents)',
    'error-contents': 'var(--fmc-color-error-contents)',
    'error-container': 'var(--fmc-color-error-container)',
    divider: 'var(--fmc-color-divider)',
    outline: 'var(--fmc-color-outline)',
    background: 'var(--fmc-color-background)'
  }
};
export { colors, theme };
